import { Eyebrow, Reveal } from "./Reveal";

const img = (id, w = 1400) =>
    `https://images.unsplash.com/${id}?q=80&w=${w}&auto=format&fit=crop`;

const PROJECTS = [
    {
        cat: "Fasad Komersial",
        title: "Kaca Structural Bangunan",
        desc: "Selubung kaca bangunan dengan grid aluminium presisi.",
        image: img("photo-1479292889369-1a48f234247e"),
        h: "h-[340px] lg:h-[520px]",
    },
    {
        cat: "Hunian",
        title: "Ruang Keluarga Terbuka",
        desc: "Interior hangat yang menyatu dengan cahaya luar.",
        image: img("photo-1724582586529-62622e50c0b3"),
        h: "h-[300px] lg:h-[420px]",
    },
    {
        cat: "Kantor",
        title: "Partisi Kaca Meeting Room",
        desc: "Ruangan kaca frameless dengan lapisan film privasi.",
        image: img("photo-1706074740295-d7a79c079562"),
        h: "h-[300px] lg:h-[420px]",
    },
    {
        cat: "Eksterior",
        title: "Bukaan Aluminium Luas",
        desc: "Fasad rumah dengan bukaan kaca selebar muka bangunan.",
        image: img("photo-1783125127082-3fb6c1bccd72"),
        h: "h-[340px] lg:h-[520px]",
    },
    {
        cat: "Dapur",
        title: "Kitchen Set Minimalis",
        desc: "Lemari kayu hangat dengan backsplash dan aksen kaca.",
        image: img("photo-1684928365167-e91916573122"),
        h: "h-[300px] lg:h-[440px]",
    },
    {
        cat: "Kamar Mandi",
        title: "Shower Glass Premium",
        desc: "Kaca tempered frameless dengan profil hitam matte.",
        image: img("photo-1765766600805-e75c44124d2c"),
        h: "h-[300px] lg:h-[440px]",
    },
];

function ProjectCard({ p }) {
    return (
        <div
            data-testid="project-card"
            className={`group relative overflow-hidden border border-white/10 bg-elevated ${p.h}`}
        >
            <img
                src={p.image}
                alt={p.title}
                loading="lazy"
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/20 to-transparent" />
            <div className="glass-panel absolute bottom-4 left-4 right-4 p-5 transition-transform duration-500 group-hover:-translate-y-1 lg:bottom-6 lg:left-6 lg:right-auto lg:max-w-[85%]">
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                    {p.cat}
                </div>
                <div className="mt-1.5 font-serif text-xl text-white lg:text-2xl">
                    {p.title}
                </div>
                <div className="mt-1 text-xs text-zinc-400 lg:text-sm">
                    {p.desc}
                </div>
            </div>
        </div>
    );
}

export default function Projects() {
    const left = PROJECTS.filter((_, i) => i % 2 === 0);
    const right = PROJECTS.filter((_, i) => i % 2 === 1);

    return (
        <section id="portofolio" className="bg-surface/40 py-24 lg:py-32">
            <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
                <Reveal>
                    <Eyebrow>Portofolio</Eyebrow>
                </Reveal>
                <div className="mt-6 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
                    <Reveal delay={0.05}>
                        <h2 className="max-w-2xl font-serif text-4xl font-medium leading-tight text-white lg:text-5xl">
                            Karya yang berbicara lewat cahaya.
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="max-w-sm text-sm leading-relaxed text-zinc-400">
                            Sebagian hasil kerja untuk hunian dan bangunan
                            komersial.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-14 grid grid-cols-1 gap-5 lg:grid-cols-2 lg:gap-x-8">
                    <div className="space-y-5 lg:space-y-8">
                        {left.map((p, i) => (
                            <Reveal key={p.title} delay={i * 0.06}>
                                <ProjectCard p={p} />
                            </Reveal>
                        ))}
                    </div>
                    <div className="space-y-5 lg:mt-28 lg:space-y-8">
                        {right.map((p, i) => (
                            <Reveal key={p.title} delay={i * 0.06 + 0.05}>
                                <ProjectCard p={p} />
                            </Reveal>
                        ))}
                    </div>
                </div>

                <Reveal className="mt-14 flex justify-center">
                    <a
                        href="#kontak"
                        data-testid="projects-cta"
                        className="rounded-full border border-white/25 px-8 py-4 font-mono text-xs uppercase tracking-[0.18em] text-white transition-[border-color,color,transform] duration-300 hover:-translate-y-0.5 hover:border-gold hover:text-gold"
                    >
                        Diskusikan Proyek Anda
                    </a>
                </Reveal>
            </div>
        </section>
    );
}
